export default __webpack_public_path__ + "static/media/suite-montanha2-main.675d3854.webp";